/* eslint-disable import/prefer-default-export */
import styled from "@emotion/styled";

export const StyleWrapperSchedule = styled.div`
    .fc-event-main {
        overflow: hidden;
    }

    .fc .fc-today-button {
        padding: 0px !important;
        height: 28px !important;
        width: 80px !important;
        margin-left: 15px;
        &:focus {
            box-shadow: none !important;
        }
    }

    .fc .fc-legend-button {
        background: transparent !important;
        border: transparent !important;
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
    }

    .fc .fc-pickCalendar-button {
        background: none !important;
        border: none !important;
        font-weight: 600 !important;
        font-size: 17px !important;
        line-height: 150%;
        font-family: "Source Sans Pro";
        font-style: normal;
    }

    .fc-daygrid-day-events {
        overflow: hidden;
    }

    .fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-header {
        background: #ffffff;
    }

    .fc .fc-popover {
        z-index: 10;
    }

    .fc-more-popover-misc {
        padding-bottom: 16px;
        > h1 {
            font-family: "Source Sans Pro" !important;
            font-style: normal !important;
            font-weight: 700 !important;
            font-size: 24px !important;
            line-height: 130% !important;
        }
    }

    .fc.fc-theme-standard .fc-view-harness .fc-popover .fc-popover-header {
        border-bottom: none;
    }

    .fc .fc-popover-title {
        font-size: 12px;
        font-weight: 400;
        line-height: 150%;
    }

    .fc-popover-header {
        padding-bottom: 0 !important;
    }

    .fc-popover-body {
        padding-top: 0 !important;
    }

    .fc-button-group .fc-pickCalendar-button {
        color: #404040 !important;
        padding-left: 0px;
    }

    .fc-button-group .fc-icon-button {
        color: #404040 !important;
        padding-left: 0px;
    }

    .fc-timegrid-event {
        margin-bottom: 0px;
    }

    div.fc-daygrid-body,
    div.fc-daygrid-body > table {
        width: 100% !important;
    }

    .fc-timegrid-body {
        table {
            width: 100% !important;
        }
    }

    .fc-daygrid-body,
    .fc-timegrid-body,
    .fc-timegrid-cols table,
    .fc-timegrid table,
    .fc-timegrid-event-harness,
    .fc-timegrid-col-events,
    .fc-timegrid-body > table,
    .fc-daygrid-body > table,
    .fc-col-header {
        width: 100% !important;
    }

    .fc-view-harness td {
        color: #29292b;
        font-size: 13px;
    }

    .fc-timegrid-event-harness {
        width: auto !important;
    }
`;

export const StyleWrapper = styled.div`
    .fc .fc-pickCalendar-button {
        background: none !important;
        border: none !important;
        font-weight: 600 !important;
        font-size: 17px !important;
        line-height: 150%;
        font-family: "Source Sans Pro";
        font-style: normal;
    }

    .fc-button-group .fc-pickCalendar-button {
        color: #404040 !important;
        padding-left: 0px;
    }

    .fc-button-group .fc-icon-button {
        color: #404040 !important;
        padding-left: 0px;
    }

    .fc.fc-theme-standard .fc-toolbar .fc-button:focus {
        box-shadow: none !important;
    }
`;
